/**
 * Session-level runtime notes (in-memory, lost on refresh).
 *
 * ## API Migration Notes
 *
 * Replace this entire store with:
 * - `POST /api/notes` in the save handler (see InterventionPanel.tsx)
 * - `GET /api/notes?patientId=...` in InterventionTab to load notes
 * - Remove `useRuntimeNotesStore` usage from InterventionTab once
 *   the query invalidation (e.g. TanStack Query) handles refetch.
 */
import { create } from "zustand";
import type { ConsultationNote } from "@/features/patients/intervention-data";

interface RuntimeNotesState {
	/** notes keyed by patient uid */
	notes: Record<string, ConsultationNote[]>;

	/** Add a new note for a patient */
	addNote: (patientId: string, note: ConsultationNote) => void;
}

export const useRuntimeNotesStore = create<RuntimeNotesState>((set) => ({
	notes: {},

	addNote: (patientId, note) =>
		set((s) => ({
			notes: {
				...s.notes,
				[patientId]: [...(s.notes[patientId] ?? []), note],
			},
		})),
}));
